import { initializeApp, database } from "firebase";

import { FirebaseConfig } from "./keys";
initializeApp(FirebaseConfig);

const databaseRef = database().ref();
export const contactRef = databaseRef.child("contacts");
